import {WEBVIEW} from "data/constants";

export function trackAdobeAnalyticsEvent(event: string, data: Record<string, unknown> = {}) {
	if (!window.dataLayer) {
		console.warn("No window.dataLayer found");
		return;
	}

	window.dataLayer.push({
		event: "Amplitude",
		eventName: event,
		webview: WEBVIEW,
		pageTitle: document.title,
		props: {...data},
	});
}
